// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  api_url: 'https://dev-api.projul.com/',
  // api_url: 'https://localhost:44313/',
  production: false,
  favicon_set: 'dev',
  JustifiClientId: 'test_90fb9085558a5b995a1f89712ba0edc7',
  logRocketAppId: 'umgzza/dev-customer-portal',
  appVersion: '2.9.0020'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
